/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} OwnedInputs */

const en_owned = /** @type {(inputs: OwnedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`You own this item`)
};

/** @type {(inputs: OwnedInputs) => LocalizedString} */
const es_owned = en_owned;

/** @type {(inputs: OwnedInputs) => LocalizedString} */
const fr_owned = en_owned;

/** @type {(inputs: OwnedInputs) => LocalizedString} */
const de_owned = en_owned;

/** @type {(inputs: OwnedInputs) => LocalizedString} */
const ja_owned = en_owned;

/** @type {(inputs: OwnedInputs) => LocalizedString} */
const zh_owned = en_owned;

/** @type {(inputs: OwnedInputs) => LocalizedString} */
const ar_owned = en_owned;

/** @type {(inputs: OwnedInputs) => LocalizedString} */
const id_owned = en_owned;

/** @type {(inputs: OwnedInputs) => LocalizedString} */
const it_owned = en_owned;

/** @type {(inputs: OwnedInputs) => LocalizedString} */
const ru_owned = en_owned;

/** @type {(inputs: OwnedInputs) => LocalizedString} */
const pt_owned = en_owned;

/** @type {(inputs: OwnedInputs) => LocalizedString} */
const ko_owned = en_owned;

/**
* | output |
* | --- |
* | "You own this item" |
*
* @param {OwnedInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const owned = /** @type {((inputs?: OwnedInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<OwnedInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_owned(inputs)
	if (locale === "es") return es_owned(inputs)
	if (locale === "fr") return fr_owned(inputs)
	if (locale === "de") return de_owned(inputs)
	if (locale === "ja") return ja_owned(inputs)
	if (locale === "zh") return zh_owned(inputs)
	if (locale === "ar") return ar_owned(inputs)
	if (locale === "id") return id_owned(inputs)
	if (locale === "it") return it_owned(inputs)
	if (locale === "ru") return ru_owned(inputs)
	if (locale === "pt") return pt_owned(inputs)
	return ko_owned(inputs)
});